import React from 'react'
import styles from './styles.module.css'
export const TableItem = ({children, style}) => {
  return (
    <div className={styles.row_item} style={style}>{children}</div>
  )
}
